// Generic route stub — empty state with the module name and the build phase
// it ships in (PRD §10). Used for every nav destination that isn't built yet.
import type { ComponentType } from 'react';
import { useI18n } from '../lib/i18n';
import type { IconProps } from '../components/icons/types';
import { PageHeader } from '../components/ui/PageHeader';

export default function ComingSoon({
  titleKey,
  phase,
  icon,
}: {
  titleKey: string;
  phase: number;
  icon?: ComponentType<IconProps> | string;
}) {
  const { t } = useI18n();
  const IconComponent = typeof icon === 'function' ? icon : null;

  return (
    <div>
      <PageHeader title={t(titleKey)} />

      <div className="mt-6 grid place-items-center rounded-card border border-line bg-white px-6 py-16 text-center shadow-card dark:border-slate-800 dark:bg-slate-900">
        <div
          className="grid h-16 w-16 place-items-center rounded-2xl bg-brand-50 text-brand dark:bg-brand-50/15 dark:text-brand-tint"
          aria-hidden
        >
          {IconComponent ? <IconComponent size={32} /> : (typeof icon === 'string' ? icon : null)}
        </div>
        <h2 className="mt-4 text-lg font-bold text-ink dark:text-slate-100">{t('coming.heading')}</h2>
        <p className="mt-1 max-w-sm text-sm text-ink-3 dark:text-slate-400">
          {t('coming.body')} <b className="text-brand">P{phase}</b>
        </p>
      </div>
    </div>
  );
}
